import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { SICOM_PATHS } from 'src/sicom-paths';

export interface DownloadPcmsoAnexoParams {
    uf: string;
    idMedico: number;
    nuRegistro: number | string;
}

export function downloadPcmsoAnexo(http: HttpClient, rootUrl: string, params: DownloadPcmsoAnexoParams, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(rootUrl, downloadPcmsoAnexo.PATH, 'get');
    rb.path('uf', params.uf, {});
    rb.path('idMedico', params.idMedico, {});
    rb.path('nuRegistro', params.nuRegistro, {});

    return http.request(rb.build({ responseType: 'blob', accept: 'application/pdf', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Blob>;
        })
    );
}

downloadPcmsoAnexo.PATH = SICOM_PATHS.registro.medico.pcmso.anexo;
